// FOLK Level to Location mapping configuration
export const folkLevelLocationMap = {
    "FOLK Foundation": "Annadanam Hall",
    "FOLK Prelims": "FPH", 
    "FOLK Enhanced": "Nitai Hall",
    "FOLK Graduate": "Gauranga Hall",
    "FOLK Plus": "Gauranga Hall",
    "AOMC": "Gadadhar Hall"
};

export const getFolkLevelLocation = (folkLevel) => {
    return folkLevelLocationMap[folkLevel] || "";
};